export enum CompanyStatus {
	Default = 0,
	Approved = 1,
	Rejected = 2,
	Pending = 3,
	Deleted = 4,
}
